/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useEffect, useState } from 'react';
import { Image, Dropdown, Menu } from "antd";
import customStyles from "../../../../assets/styles/customStyles";
import clsx from 'clsx';
import { NavLink } from "react-router-dom";
import hamburgerMenu from "../../../../assets/images/icon_actions/hamburgerMenu.svg";
import zoomIn from "../../../../assets/images/icon_actions/zoom-in.png";
import zoomOut from "../../../../assets/images/icon_actions/zoom-out.png";
import pan from "../../../../assets/images/icon_actions/pan.png";
import ReactApexChart from "react-apexcharts";
import { capitalizeFirstLetter, exportChatFile, downloadImageCommon, numDifferentiation } from "../../../../helpers/utilities";
import useMediaQuery from '@mui/material/useMediaQuery';

export const ClientProfiling = (props) => {
    const { title, details } = props;
    const classes = customStyles();
    const clientProfiling = useRef(null);
    const [paying, setPaying] = useState([]);
    const [nonPaying, setNonPaying] = useState([]);
    const [data, setData] = useState([]);
    const showText = useMediaQuery('(min-width:1300px)');

    const handleImageDownload = (type) => {
        if (type === 'csv') {
            exportFile();
        } else {
            downloadImageCommon(clientProfiling.current, title, type);
        }
    }

    useEffect(() => {
        Object.keys(details).length > 0 && Object?.entries(details)?.map(([i, detail]) => {
            setPaying((prevState) => {
                return [...prevState, detail?.paying];
            });
            setNonPaying((prevState) => {
                return [...prevState, detail?.nonpaying];
            });
            setData((prevState) => {
                return [...prevState, capitalizeFirstLetter(i)];
            });

            return () => {
                setPaying([]);
                setNonPaying([]);
                setData([]);
            }
        });
    }, []);


    const exportFile = () => {
        let newHead = [['Top Area Sales Total', 'Top City Sales Total', 'Sales Total']];
        exportChatFile(title, newHead);
    }

    const chartData = {
        chart: {
            type: "line",
            offsetY: -20,
            redrawOnWindowResize: true,
            toolbar: {
                show: showText ? true : false,
                tools: {
                    download: `<img src="${hamburgerMenu}" width="20">`,
                    selection: false,
                    zoom: false,
                    zoomin: `<img src="${zoomIn}" width="20">`,
                    zoomout: `<img src="${zoomOut}" width="20">`,
                    pan: `<img src="${pan}" width="20">`,
                    reset: false | '<img src="/static/icons/reset.png" width="20">',
                    customIcons: [],
                },
                offsetX: 15,
                offsetY: 3
            }
        },
        tooltip: {
            enabled: true,
            style: {
                fontSize: '13px',
                fontFamily: 'Roboto',
                fontWeight: 500,
            },
            custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                return '<div class="arrow_box">' +
                    '<div class="client_profile_title">' + w.globals.categoryLabels[dataPointIndex] + '</div>' +
                    '<div class="client_profile"><span>Paying</span><span>: ' + series[0][dataPointIndex] + ' Nos.</span></div>' +
                    '<div class="client_profile"><span>Non-Paying</span><span>: ' + series[1][dataPointIndex] + ' Nos.</span></div>' +
                    '</div>';
            }
        },
        legend: {
            show: showText ? true : false,
            position: 'top',
            horizontalAlign: 'right',
            offsetY: 10,
            markers: {
                radius: 0,
            },
        },
        plotOptions: {
            bar: {
                columnWidth: '80%',
            }
        },
        fill: {
            opacity: 1
        },
        stroke: {
            show: true,
            width: 0,
            colors: ['transparent']
        },
        states: {
            hover: {
                filter: {
                    type: 'darken',
                    value: 1,
                }
            },
        },
        xaxis: {
            type: 'category',
            axisTicks: {
                show: false,
            },
            labels: {
                rotate: -35,
                rotateAlways: true,
                offsetY: -5,
                style: {
                    fontFamily: "Roboto",
                    fontSize: "9px",
                },
                hideOverlappingLabels: false,
            },
            categories: data,
            title: {
                text: '',
            },
            crosshairs: {
                show: true,
                stroke: {
                    color: '#d20b0b',
                    width: 1,
                    dashArray: 4,
                },
            },
            tooltip: {
                enabled: false,
            },
        },
        yaxis: [{
            labels: {
                style: {
                    fontFamily: "Roboto",
                    fontSize: showText ? 11 : 9,
                },
                formatter: function (val, index) {
                    return numDifferentiation(val);
                }
            },
        }],
        title: {
            text: `${title}`,
            style: {
                color: "#14a4c2",
                fontSize: '14px',
                fontFamily: 'Roboto',
                fontWeight: 500,
            },
            offsetX: -30,
            offsetY: 20
        },
        series: [
            {
                color: "#1c314c",
                name: 'Paying Clients',
                type: 'column',
                data: paying
            },
            {
                color: "#8ac8d5",
                name: 'Non-Paying Clients',
                type: 'column',
                data: nonPaying
            }
        ]
    };

    return (
        <div ref={clientProfiling}>
            <div className={clsx(classes.chartDiv, classes.chartDivClient)}>
                <span className={clsx(classes.hamburgerMenu, classes.chartDivDownload, 'customhamburgerIcon')}>
                    <Dropdown
                        placement="bottomLeft"
                        trigger={['click']}
                        overlay={
                            <Menu className={clsx(classes.groupMenu, classes.hamburgeGroupMenu)}>
                                <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('png')}>Download PNG</NavLink></Menu.Item>
                                <Menu.Item><NavLink to={'#'} onClick={() => handleImageDownload('csv')}>Download CSV</NavLink></Menu.Item>
                            </Menu>
                        }>
                        <Image src={hamburgerMenu} preview={false} />
                    </Dropdown>
                </span>
                <div className={classes.invoiceAmount}>Number of Clients</div>
                <div className={clsx(classes.invoiceMonths, classes.invoiceMonthsClients)}>Client Profile</div>
                <ReactApexChart options={chartData} series={chartData.series} />
            </div>
        </div >

    )
}